import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import './styles.css';
import AssignmentInfo from '../../../assignments/info';
import Alert from '../../../alert';
import { studentCountQuery } from '../../../../Instructor/insights/api';

const REVIEW_SESSION_MIN_STUDENTS = 20;

export default function InstructorAddAssignmentsRow({isLaunchReviewSessionButtonDisabled}) {
  const navigate = useNavigate();

  const { data: studentCount } = useQuery(studentCountQuery());

  const [isReviewSessionInfoVisible, setIsReviewSessionInfoVisible] = useState(false);
  const [isMinStudentsAlertVisible, setIsMinStudentsAlertVisible] = useState(false);

  const handleInfoButtonMouseEnter = () => {
    setIsReviewSessionInfoVisible(true);
  }

  const handleInfoButtonMouseLeave = () => {
    setIsReviewSessionInfoVisible(false);
  }

  const handleLaunchReviewSessionClick = () => {
    const count = studentCount || 0;
    if (count < REVIEW_SESSION_MIN_STUDENTS) {
      setIsMinStudentsAlertVisible(true);
      return;
    }
    navigate('/instructor/settings/tournament/new');
  }

  const handleMinStudentsAlertConfirm = () => {
    setIsMinStudentsAlertVisible(false);
  }

  const reviewSessionInfoContent = <>
    <span>Turn review time into a live competition that keeps the whole class participating.</span>
    <ul>
      <li>Select the exercises to review (Classification, Normal Balance, Accounting Equation, Principles)</li>
      <li>Assign the exercise(s) to a round</li>
      <li>Students are placed in teams and answer individually</li>
    </ul>
    <span>Great for reinforcing Accounting Basics before moving to advanced topics.</span>
  </>;

  const minStudentsAlertText = (
    <>
      Review Sessions require at least {REVIEW_SESSION_MIN_STUDENTS} students on your roster. You currently have {studentCount || 0}. Head to the <b>Roster</b> page to add more, then try again.
    </>
  );

  return (
    <div className="instructor-assignments">
      <div className="add-assignment">
        <button
          className="button-red button-add-review"
          onClick={handleLaunchReviewSessionClick}
          onMouseEnter={handleInfoButtonMouseEnter}
          onMouseLeave={handleInfoButtonMouseLeave}
          disabled={isLaunchReviewSessionButtonDisabled}
        >
          <span>+</span> Launch Review Session
        </button>
        <button className="button-blue button-add-assignment" data-tour-id="assignment-button" onClick={() => navigate('add')}>
          <span>+</span> Assignment
        </button>
      </div>
      <hr />
      {
        isReviewSessionInfoVisible &&
          <AssignmentInfo
            title="Review Sessions"
            description={reviewSessionInfoContent}
            className="review-session-info"
          />
      }
      {
        isMinStudentsAlertVisible &&
          <Alert
            type="warning"
            title="Not enough students"
            text={minStudentsAlertText}
            confirmButtonText="Ok"
            onConfirmButtonClick={handleMinStudentsAlertConfirm}
            size="big"
          />
      }
    </div>
  );
}
